<template>
  <div class="info-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="text-center">
            <h1 class="hero-title mb-2">운영 안내 및 환불 규정</h1>
            <div class="hero-subtitle mb-6">Why Choose Our Tutoring Service</div>
            <p class="hero-description">We help you achieve fluency faster with our proven approach</p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Info Cards Section -->
    <section class="info-cards-section">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4" class="text-center mb-6">
            <v-card class="info-card mx-auto" rounded="lg" elevation="3" ref="ref-info-rule">
              <div class="card-content">
                <div class="card-title-container">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-clock-outline</v-icon>
                  </div>
                  <h3 class="card-title">수업 시간 안내</h3>
                </div>
                <v-img 
                  class="card-img mx-auto my-4" 
                  max-height="180" 
                  contain
                  :src="`${app.cdnUrl}/website/main/info/class_time.png`" 
                />
                <div class="card-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>유연한 수업 시간 (오전 8시 ~ 오후 11시)</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>20회 수강권 기준 횟수 차감 방식</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>수업 연기 5회 가능</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="12" sm="6" md="4" class="text-center mb-6">
            <v-card class="info-card mx-auto" rounded="lg" elevation="3">
              <div class="card-content">
                <div class="card-title-container">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-laptop</v-icon>
                  </div>
                  <h3 class="card-title">온라인 수업</h3>
                </div>
                <v-img 
                  class="card-img mx-auto my-4" 
                  max-height="180" 
                  contain
                  :src="`${app.cdnUrl}/website/main/info/online_lesson.png`" 
                />
                <div class="card-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>무료 레벨 테스트 제공</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>결제 영수증, 출석증 제공</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>Teams, Zoom 앱 기반 수업</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="12" sm="6" md="4" class="text-center mb-6">
            <v-card class="info-card mx-auto" rounded="lg" elevation="3">
              <div class="card-content">
                <div class="card-title-container">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-account-tie</v-icon>
                  </div>
                  <h3 class="card-title">선생님 배정</h3>
                </div>
                <v-img 
                  class="card-img mx-auto my-4" 
                  max-height="180" 
                  contain
                  :src="`${app.cdnUrl}/website/main/info/teacher_assignment.png`" 
                />
                <div class="card-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>담당 선생님 지정 및 고정 수업</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>선생님 변경 요청시 즉시 반영</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>카카오톡으로 요청시 신속 처리</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="12" sm="6" md="4" class="text-center mb-6">
            <v-card class="info-card mx-auto" rounded="lg" elevation="3" ref="ref-info-attend">
              <div class="card-content">
                <div class="card-title-container">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-calendar-clock</v-icon>
                  </div>
                  <h3 class="card-title">수업 일정 조정</h3>
                </div>
                <v-img 
                  class="card-img mx-auto my-4" 
                  max-height="180" 
                  contain
                  :src="`${app.cdnUrl}/website/main/info/class_reschedule.png`" 
                />
                <div class="card-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>수업 시작 10분 전까지 연기 신청 가능</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>월 5회까지 수업 연기 가능</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>사이트를 통한 신청 필수</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="12" sm="6" md="4" class="text-center mb-6">
            <v-card class="info-card mx-auto" rounded="lg" elevation="3">
              <div class="card-content">
                <div class="card-title-container">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-currency-usd</v-icon>
                  </div>
                  <h3 class="card-title">환불 규정</h3>
                </div>
                <v-img 
                  class="card-img mx-auto my-4" 
                  max-height="180" 
                  contain
                  :src="`${app.cdnUrl}/website/main/info/payment_refund.png`" 
                />
                <div class="card-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>1/3 미만(6회) 수강: 2/3 환불</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>1/2 미만(10회) 수강: 1/2 환불</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>수업 하루 전까지 카톡으로 요청</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="12" sm="6" md="4" class="text-center mb-6">
            <v-card class="info-card mx-auto" rounded="lg" elevation="3" ref="ref-info-refund">
              <div class="card-content">
                <div class="card-title-container">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-tag-outline</v-icon>
                  </div>
                  <h3 class="card-title">합리적인 가격</h3>
                </div>
                <v-img 
                  class="card-img mx-auto my-4" 
                  max-height="180" 
                  contain
                  :src="`${app.cdnUrl}/website/marketing/price_comparison.png`" 
                />
                <div class="card-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>타사 대비 50% 저렴한 가격</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>효율적인 운영 구조</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="icon-check">mdi-check-circle</v-icon> 
                    <span>투명한 비용 정책</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
    
    <!-- Detailed Info Section (Hidden by default, shown when "자세히 보기" is clicked) -->
    <section class="detailed-info-section" v-if="showDetailed">
      <v-container>
        <v-row>
          <v-col cols="12" md="8" offset-md="2">
            <v-card class="detailed-card pa-6" rounded="lg" elevation="3">
              <h2 class="text-center mb-4">{{ detailedTitle }}</h2>
              <v-divider class="mb-4"></v-divider>
              <div class="detailed-content">
                <Markdown :markdown="detailedContent" />
              </div>
              <div class="d-flex justify-center mt-4">
                <v-btn color="primary" @click="showDetailed = false" rounded>닫기</v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import Markdown from '@/components/Markdown'
import {mapGetters} from "vuex";

export default {
  name: 'Teacher',
  data() {
    return {
      showDetailed: false,
      detailedTitle: '',
      detailedContent: '',
      infoRule: '### 수업 시간 안내\n' +
          '- **유연한 수업 시간** : 오전 8시 ~ 오후 11시 (학습자 편의 고려)\n' +
          '- **효율적인 관리** : 20회 수강권 기준 횟수 차감 방식(수업 연기 5회 가능)\n' +
          '---\n' +
          '### 휴무 안내\n' +
          '- 한국, 필리핀 공휴일 휴무\n' +
          '- 현지 인터넷, 전력 문제로 인한 수업 불가시 보강 제공\n',

      infoRegister: '### 기본 제공 서비스\n' +
          '- **무료 레벨 테스트** : 정확한 학습자 수준 파악\n' +
          '- **공식 문서 발급** : 결제 영수증, 출석증 제공\n' +
          '---\n' +
          '### 수업 방식\n' +
          '- **편리한 온라인 수업** : Teams, Zoom 앱 기반 수업\n' +
          '- **동일 가격 정책** : 화상 / 음성 통화 동일 가격 적용\n',

      infoTeacher: '### 선생님 배정 시스템\n' +
          '- **맞춤형 교육** : 담당 선생님 지정 및 고정 수업 시간 제공\n' +
          '- **유연한 변경 정책** : 선생님 변경 요청시, 다음 수업일부터 즉시 반영\n' +
          '- **간편한 요청 절차** : 카카오톡으로 요청시 신속하게 처리해 드립니다.\n',

      infoPrice: '### 합리적인 가격 정책\n' +
          '- **타사 대비 50% 저렴한 가격** : 경쟁사 대비 절반 가격으로 양질의 수업 제공\n' +
          '- **효율적인 운영 구조** : 개발자 출신이 직접 운영하여 중간 마진 최소화\n' +
          '- **직접 연결 시스템** : 강사와 학습자를 직접 연결하는 효율적인 구조\n' +
          '- **투명한 비용 구조** : 운영비용 최소화로 높은 품질의 서비스 제공\n',

      infoAttend: '' +
          '### 수업 보충 제도\n' +
          '개인적인 사정으로 수업 참석이 어려운 경우를 위한 유연한 보충 시스템을 운영합니다.\n\n' +
          '**보충 수업 신청 방법**\n' +
          '- 수업 시작 최소 10분 전에 My Class(수강현황) 화면에서 수업연기 요청\n' +
          '- 월 5회까지 보충 수업 가능 (학습 연속성 유지 목적)\n' +
          '**주의사항**\n' +
          '- 선생님께 직접 전달하거나 문자로만 알리는 경우 시스템에 반영되지 않을 수 있으니 반드시 사이트를 통해 신청해 주세요.\n' +
          '- 연장수업은 수업 마지막날을 기준으로 처리됩니다.\n\n' +
          '**예시**\n' +
          '- 수업일 : 1월1일(목)~ 1월28일(수) 인 경우\n' +
          '- 2번 연장 요청시 : 연장일은 29일(목), 30(금)일까지 수업 진행\n' +
          '- 3번 연장 요청시 : 연장일은 29일(목), 30일(금), 31(토), 2/1(일), 2/2(월)까지\n' +
          '  (주말을 제외하고 연장 처리됩니다)\n' +
          '- 보충 수업은 선생님 스케줄에 따라 평일 또는 주말에 진행될 수 있습니다.\n',
          
      infoRefund: '### 투명한 환불 규정\n' +
          '영어문의 수업료 환불 규정은 학원법을 준수하여 아래와 같이 명확하게 적용됩니다.\n\n' +
          '**1개월/총 20회 수업 기준**\n' +
          '- 총 교습시간의 1/3 미만(6회) 수강 : 수강료의 2/3 해당액 환불\n' +
          '- 총 교습시간의 1/2 미만(10회) 수강 : 수강료의 1/2 해당액 환불\n' +
          '- 총 교습시간의 1/2 경과 후 : 환불 불가\n\n' +
          '**환불 신청 방법**\n' +
          '- 환불 신청은 수업 하루 전까지 카카오톡으로 요청\n' +
          '- 최초 결제 방법과 동일한 방식으로 환불 처리\n' +
          '- 수업 당일 환불 요청 시에는 해당 수업은 진행된 것으로 처리됩니다.\n\n' +
          '※ 수업 연장일은 환불 계산에 포함되지 않습니다.'
    }
  },
  components: {
    Markdown
  },
  computed: {
    ...mapGetters(['app']),
  },
  created() {
  },
  methods: {
    showDetailedInfo(title, content) {
      this.detailedTitle = title;
      this.detailedContent = content;
      this.showDetailed = true;
    }
  },
  mounted() {
    if(this.$route.query.position) {
      this.$refs['ref-'+ this.$route.query.position].scrollIntoView({behavior: 'smooth'})
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
@import "@/assets/scss/elegant-theme.scss";

.info-page {
  background-color: #f9f9f9;
  min-height: 100vh;
}

.hero-section {
  padding: 60px 0 40px;

  
  .hero-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #334155;
    margin-bottom: 0.5rem;
    letter-spacing: -0.5px;
  }
  
  .hero-subtitle {
    font-size: 1.3rem;
    color: #3b82f6;
    font-weight: 600;
  }
  
  .hero-description {
    font-size: 1.1rem;
    color: #64748b;
    max-width: 600px;
    margin: 0 auto;
  }
}

.info-cards-section {
  padding: 40px 0 80px;
  margin-top: -20px;
}

.info-card { 
  height: 100%;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1) !important;
  }
  
  .card-content {
    padding: 30px 20px;
  }
  
  .card-title-container {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .icon-wrapper {
    background-color: rgba(59, 130, 246, 0.1);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    flex-shrink: 0;
  }
  
  .card-title {
    font-size: 1.4rem;
    font-weight: 600;
    color: #1e40af;
    margin-bottom: 0;
  }
  
  .card-img {
    border-radius: 8px;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  .card-details {
    text-align: left;
    margin: 0 auto;
    max-width: 280px;
  }
  
  .detail-item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    
    .icon-check {
      margin-top: 3px;
      margin-right: 8px;
      flex-shrink: 0;
    }
    
    span {
      font-size: 0.95rem;
      color: #334155;
      line-height: 1.4;
    }
  }
}

.detailed-info-section {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  
  .detailed-card {
    max-width: 800px;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .detailed-content {
    h3, h4, h5 {
      margin-bottom: 16px;
      color: #1e40af;
      font-weight: 600;
    }
    
    p, li {
      color: #334155;
      line-height: 1.6;
    }
    
    strong, b {
      color: #3b82f6;
    }
  }
}

// Dark mode support
.v-application.theme--dark {
  .info-page {
    background-color: #121212;
  }
  
  .hero-section {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d3748 100%);
    
    .hero-title {
      color: #e2e8f0;
    }
    
    .hero-subtitle {
      color: #60a5fa;
    }
    
    .hero-description {
      color: #a0aec0;
    }
  }
  
  .info-card {
    background-color: #1e1e1e !important;
    
    .card-title {
      color: #60a5fa;
    }
    
    .detail-item {
      color: #e2e8f0;
    }
  }
}

// Responsive adjustments
@media (max-width: 960px) {
  .hero-section {
    padding: 40px 0 30px;
    
    .hero-title {
      font-size: 2rem;
    }
    
    .hero-subtitle {
      font-size: 1.1rem;
    }
  }
  
  .info-card {
    margin-bottom: 16px;
  }
}
</style>